import { ADD_INPUT_WITH_PROPS, EDIT_INPUT_WITH_PROPS, REMOVE_INPUT_WITH_PROPS  } from '../actions/inputWithProps';

// !!! this reducer is supposed to store input values and return MUTABLE state to prevent content re rendering
export default (state = new Map(), action) => {
    switch (action.type) {
        case ADD_INPUT_WITH_PROPS: {
            const { typeId } = action.payload;
            state.set(typeId.id, { type: typeId.type });
            return state;
        }

        case EDIT_INPUT_WITH_PROPS: {
            const { id, props } = action.payload;
            let curValue = state.get(id);
            if (curValue) {
                curValue = props
                state.set(id, curValue);
            }
            return state;
        }

        case REMOVE_INPUT_WITH_PROPS: {
            state.delete(action.payload);
            return state;
        }

        default: return state;
    }
}